import React, { useState } from 'react';
import PutBody from '../../../api/internal/PutBody';
import classes from '../../../assets/Global.module.css';
import Select from '../../../assets/essentials/Select';
import OptionList from '../../../helpers/options/OptionList';
import Button from '../../../assets/essentials/Button';
import Modal from '../../../helpers/modal/Modal';
import Create from '../../../helpers/modal/CreateModal';
import CloseModal from '../../../helpers/modal/CloseModal';
import CloseSlab from '../../../helpers/slab/Close';

const Admin = ({
  data,
  vendorAssignmentId,
  RefreshPage,
}: {
  data: PayableAdmin;
  vendorAssignmentId: Number;
  RefreshPage: Function;
}) => {
  const { paymentStatusId, paymentStatusOptions } = data;
  const [selectedPaymentStatusId, setSelectedPaymentStatusId] =
    useState(paymentStatusId);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdatePayableAdmin = () => {
    setIsLoading(true);
    PutBody('/Accounting/UpdatePayableAdmin', {
      vendorAssignmentId: vendorAssignmentId,
      paymentStatusId: selectedPaymentStatusId,
    })
      .then(response => {
        if (response) {
          RefreshPage('Admin', ['Audit', 'Summary']);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DeleteBillModal = () => {
    const handleDeleteBill = () => {
      PutBody('/Accounting/UpdatePayableAdmin', {
        vendorAssignmentId: vendorAssignmentId,
        isActive: !data.isActive,
      }).then(response => {
        if (response) {
          CloseModal();
          CloseSlab();
        }
      });
    };
    return (
      <Modal>
        <div className={classes.flexColumnAlignCenter}>
          <h4>Delete Bill</h4>
          <p>
            Are you sure you want to {data.isActive ? 'delete' : 'restore'} this
            bill?
          </p>
          <div className={classes.sideBySideButtons}>
            <Button
              onClick={handleDeleteBill}
              variant={data.isActive ? 'bad' : 'good'}
            >
              {data.isActive ? 'Delete' : 'Restore'}
            </Button>
            <Button onClick={CloseModal}>Cancel</Button>
          </div>
        </div>
      </Modal>
    );
  };

  const handleClick = () => {
    Create(<DeleteBillModal />);
  };

  return (
    <>
      <div className={`${classes.span3} ${classes.attribute}`}>
        <label>Payment Status</label>
        <Select
          value={selectedPaymentStatusId?.toString() || ''}
          onChange={e => setSelectedPaymentStatusId(parseInt(e.target.value))}
        >
          <OptionList
            optionData={paymentStatusOptions}
            attributeID="paymentStatusId"
            attributeName="status"
          />
        </Select>
      </div>
      <div>
        <Button
          onClick={handleUpdatePayableAdmin}
          disabled={isLoading}
          variant="good"
          type="button"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
      <br />
      <div>
        <Button variant={data.isActive ? 'bad' : ''} onClick={handleClick}>
          {data.isActive ? 'Delete' : 'Restore'} Bill
        </Button>
      </div>
    </>
  );
};

export default Admin;
